import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";
import "./WebProject.scss";
import { 
  trackSectionView, 
  trackProjectView, 
  trackProjectModalOpen,
  trackTimeOnSection 
} from "../utils/analytics";

class WebProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deps: {},
      detailsModalShow: false,
    };
    this.sectionRef = React.createRef();
    this.sectionStartTime = null;
    this.hasTrackedView = false;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.trackTimeSpent();
  }

  setupIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sectionStartTime = Date.now();
            if (!this.hasTrackedView) {
              trackSectionView('web_projects');
              this.hasTrackedView = true;
            }
          } else {
            this.trackTimeSpent();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  };

  trackTimeSpent = () => {
    if (this.sectionStartTime) {
      const timeSpent = Math.round((Date.now() - this.sectionStartTime) / 1000);
      if (timeSpent > 1) {
        trackTimeOnSection('web_projects', timeSpent);
      }
      this.sectionStartTime = null;
    }
  };

  render() {
    let detailsModalShow = (data) => {
      trackProjectView(data.title, 'web');
      trackProjectModalOpen(data.title);
      this.setState({ detailsModalShow: true, deps: data });
    };

    let detailsModalClose = () => this.setState({ detailsModalShow: false });
    
    if (this.props.resumeProjects && this.props.resumeBasicInfo) {
      var projects = this.props.resumeProjects.map(function (projects, index) {
        return (
          <div className="project-card" key={projects.title} style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="project-image-wrapper">
              <img
                src={projects.images[0]}
                alt={`${projects.title} web project interface screenshot`}
                className="project-image"
                loading="lazy"
                decoding="async"
              />
              <div className="project-overlay">
                <div className="project-actions">
                  <button 
                    className="view-details-btn"
                    onClick={() => detailsModalShow(projects)}
                  >
                    <span className="btn-icon">👁️</span>
                    View Details
                  </button>
                </div>
              </div>
              {!!projects.startDate && (
                <div className="project-date">{projects.startDate}</div>
              )}
            </div>
            
            <div className="project-content">
              <h3 className="project-title">{projects.title}</h3>
              <p className="project-description">
                {projects.description || "Click to view more details about this project"}
              </p>
              
              <div className="project-tech">
                {projects.technologies && projects.technologies.slice(0, 3).map((tech, i) => (
                  <span key={i} className="tech-tag">{tech.name}</span>
                ))}
                {projects.technologies && projects.technologies.length > 3 && (
                  <span className="tech-more">+{projects.technologies.length - 3} more</span>
                )}
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <section className="web-projects-section" id="web-projects" ref={this.sectionRef}>
        <div className="container">
          <div className="projects-header">
            <h2 className="section-title">Web Projects</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              Showcase of web applications and digital experiences I've built
            </p>
          </div>
          
          <div className="projects-grid">
            {projects}
          </div>
          
          <ProjectDetailsModal
            show={this.state.detailsModalShow}
            onHide={detailsModalClose}
            data={this.state.deps}
          />
        </div>
      </section>
    );
  }
}

export default WebProject;
